import { useLocStore } from "../../../localization";
import { LocContext } from "../../../localization/LocContext";
import { useEvaluatedLocale } from "../../../localization/useEvaluatedLocale";
import { useLocales } from "../../../localization/useLocales";
import { useSetLocale } from "../../../localization/useSetLocale";
import { CustomMenuItem } from "../MenuItems/completeMenuItem";

export function useLanguageMenuItem() {
  const L = useLocStore(LocContext.PROFILE);
  const locales = useLocales();
  const evaluatedLocale = useEvaluatedLocale();
  const { setLocale } = useSetLocale();

  const langItems = Object.values(locales).map((locale) => ({
    label: locale.label,
    value: locale.cvpLocale,
    className: "language-item",

    isSelected: () => locale.cvpLocale === evaluatedLocale,
    onClick: () => {
      setLocale(locale.cvpLocale);
    },
  }));

  return {
    path: "",
    label: L.id("54937e799445").split("Språk: {0}", [
      locales[evaluatedLocale]?.label,
    ]),
    icon: "pi pi-fw pi-language",
    items: langItems,
    isSelected: () => false,
  } as CustomMenuItem;
}
